import { Settings } from './types'

export async function getSettings(useMSEntra: boolean): Promise<Settings> {
  const headers = {
    'Content-type': 'application/json; charset=UTF-8'
  }
  const request = await fetch(`./frontendconfiguration.json?useMSEntra=${useMSEntra}`, { headers })
  return await request.json()
}
